import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";

export default function Maintenance({ plans }) {
  const { t, dyn } = useLang();
  return (
    <section id="forvaltning" data-testid="maintenance-section" className="bg-coal py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="07" label={t("maintenance.tag")} />
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end">
          <SectionHeading>{t("maintenance.heading")}</SectionHeading>
          <Reveal delay={0.15}>
            <p className="max-w-md text-base leading-relaxed text-fog lg:ml-auto">
              {t("maintenance.sub")}
            </p>
          </Reveal>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {plans.map((plan, i) => (
            <Reveal key={`${plan.name}-${i}`} delay={0.08 + i * 0.1} className="h-full">
              <article
                data-testid={`maintenance-card-${i}`}
                className={`h-full rounded-2xl border p-8 transition-colors duration-500 ${
                  plan.recommended
                    ? "border-mint/30 bg-forest/20"
                    : "border-white/10 bg-surface hover:border-white/20"
                }`}
              >
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-display text-lg font-bold tracking-tight text-bone">{plan.name}</h3>
                  {plan.badge && (
                    <span className="rounded-full bg-mint/15 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-mint">
                      {dyn(plan.badge)}
                    </span>
                  )}
                </div>
                <p data-testid={`maintenance-price-${i}`} className="mt-4 font-display text-3xl font-extrabold tracking-tight text-mint">
                  {plan.price}
                </p>
                {plan.payLink && (
                  <a
                    data-testid={`maintenance-paylink-${i}`}
                    href={plan.payLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.2em] text-mint transition-colors hover:text-bone"
                  >
                    {t("pricing.pay")} <ArrowUpRight className="h-3 w-3" />
                  </a>
                )}
                <p className="mt-3 text-sm leading-relaxed text-fog">{dyn(plan.description)}</p>
                <ul className="mt-6 space-y-2.5">
                  {plan.features.map((f, j) => (
                    <li key={j} className="flex items-start gap-2.5 text-sm text-bone/75">
                      <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-moss" />
                      {dyn(f)}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
